import { axios } from '..';

const { REACT_APP_API_GATEWAY } = process.env;

export async function autocomplete(
  query: string,
  at: string,
  countryCode: string
): Promise<{ label: string; countryCode?: string; highlights?: { title: any[] } }[]> {
  const url = `${REACT_APP_API_GATEWAY}/address/autocomplete`;

  const response = await axios.get(url, {
    params: {
      query,
      at,
      countryCode,
    },
  });
  return response.data;
}
